<template>
  <div>
    <label style="display: block; font-size: 0.875rem; font-weight: 500; color: #374151; margin-bottom: 0.125rem;">Forma de pagamento</label>
    <p style="font-size: 0.8125rem; color: #6b7280; margin: 0 0 0.625rem 0;">Como deseja receber a cobrança?</p>
    <div class="payment-method-options">
      <button
        type="button"
        class="payment-option-card"
        :class="{ 'payment-option-card-selected': value === 'credit_card' }"
        @click="select('credit_card')">
        <span class="payment-option-radio">
          <span v-if="value === 'credit_card'" class="payment-option-radio-dot"></span>
        </span>
        <span class="payment-option-icon-wrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="payment-option-icon">
            <rect width="20" height="14" x="2" y="5" rx="2"></rect>
            <line x1="2" x2="22" y1="10" y2="10"></line>
          </svg>
        </span>
        <span class="payment-option-content">
          <span class="payment-option-label">Cartão de crédito</span>
          <span class="payment-option-hint">Instantâneo</span>
        </span>
      </button>

      <button
        type="button"
        class="payment-option-card"
        :class="{ 'payment-option-card-selected': value === 'pix' }"
        @click="select('pix')">
        <span class="payment-option-radio">
          <span v-if="value === 'pix'" class="payment-option-radio-dot"></span>
        </span>
        <span class="payment-option-icon-wrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="payment-option-icon payment-option-icon-qr" aria-hidden="true">
            <path d="M4 4h6v6H4V4Zm10 10h6v6h-6v-6Zm0-10h6v6h-6V4Zm-4 10h.01v.01H10V14Zm0 4h.01v.01H10V18Zm-3 2h.01v.01H7V20Zm0-4h.01v.01H7V16Zm-3 2h.01v.01H4V18Zm0-4h.01v.01H4V14Z"/>
            <path d="M7 7h.01v.01H7V7Zm10 10h.01v.01H17V17Z"/>
          </svg>
        </span>
        <span class="payment-option-content">
          <span class="payment-option-label">PIX</span>
          <span class="payment-option-hint">Até 24h</span>
        </span>
      </button>

      <button
        type="button"
        class="payment-option-card"
        :class="{ 'payment-option-card-selected': value === 'boleto_pix' }"
        @click="select('boleto_pix')">
        <span class="payment-option-radio">
          <span v-if="value === 'boleto_pix'" class="payment-option-radio-dot"></span>
        </span>
        <span class="payment-option-icon-wrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="payment-option-icon lucide lucide-banknote">
            <rect width="20" height="12" x="2" y="6" rx="2"></rect>
            <circle cx="12" cy="12" r="2"></circle>
            <path d="M6 12h.01M18 12h.01"></path>
          </svg>
        </span>
        <span class="payment-option-content">
          <span class="payment-option-label">Boleto bancário / PIX</span>
          <span class="payment-option-hint">Até 3 dias úteis</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethodSelector',
  props: {
    // 'credit_card' | 'pix' | 'boleto_pix'
    value: {
      type: String,
      default: 'credit_card'
    }
  },
  methods: {
    select (method) {
      this.$emit('input', method)
    }
  }
}
</script>

<style scoped>
.payment-method-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.625rem;
}

.payment-option-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 0.625rem 0.75rem;
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.2s, background-color 0.2s;
}

.payment-option-card:hover {
  border-color: #d1d5db;
}

.payment-option-card-selected {
  border-color: #2563eb;
  background-color: #eff6ff;
}

.payment-option-radio {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.125rem;
  height: 1.125rem;
  border: 2px solid #2563eb;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-option-radio-dot {
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  background-color: #2563eb;
}

.payment-option-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  min-width: 0;
}

.payment-option-icon-wrap {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-option-icon {
  color: #4b5563;
  width: 1rem;
  height: 1rem;
}

.payment-option-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.2;
}

.payment-option-hint {
  font-size: 0.6875rem;
  color: #6b7280;
  line-height: 1.2;
}

@media (max-width: 640px) {
  .payment-method-options {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/invite/PaymentMethodSelector.vue